/**
 * EllipsisTooltip
 * @author Zongqi Wei
 */
import React from 'react';
import { Tooltip } from 'antd';
import areEqual from '@utils/reactUtils/areEqual';
import styles from './index.less';

const getPopupContainer = () => document.body;

export default class EllipsisTooltip extends React.PureComponent {

  static defaultProps = {
    text: '',
    tooltipText: '',
    className: '',
    children: '',
    getPopupContainer,
  }

  timer = null

  state = {
    showEllipsis: false,
  }
  spanRef: React.RefObject<HTMLInputElement>;

  constructor(props) {
    super(props);
    this.spanRef = React.createRef();
  }

  async componentDidMount() {
    await this.computeEllipsis();
  }

  async componentDidUpdate(prevProps) {
    const { children: prevChildren, ...prevRest } = prevProps;
    const { children, ...rest } = this.props;
    if (!areEqual(prevRest, rest)) {
      await this.computeEllipsis();
    }
  }

  computeEllipsis = () => new Promise<void>((resolve) => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      const node = this.spanRef.current;
      const { showEllipsis } = this.state;
      if (!node) {
        return;
      }
      const currentShowEllipsis = node.scrollWidth > node.clientWidth;
      if (showEllipsis !== currentShowEllipsis) {
        this.setState(() => ({
          showEllipsis: currentShowEllipsis,
        }), () => {
          resolve();
        });
      }
    }, 0);
  })

  render() {
    const {
      text,
      tooltipText,
      className,
      children,
      getPopupContainer: getPopupContainerFromProps,
    }: any = this.props;
    const { showEllipsis } = this.state;
    const classes = `${styles.ellipsisTooltipWrapper} ${className}`;
    if (showEllipsis) {
      return (
        <Tooltip
          title={tooltipText || text}
          getPopupContainer={getPopupContainerFromProps}
        >
          <span className={classes} ref={this.spanRef}>{children || text}</span>
        </Tooltip>
      );
    }

    return (
      <span className={classes} ref={this.spanRef}>{children || text}</span>
    );
  }
}
